import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Buildings } from "@phosphor-icons/react";

const F = ({ label, children, className = "" }) => <div className={className}><Label className="text-xs uppercase tracking-wide">{label}</Label><div className="mt-1.5">{children}</div></div>;

export function CompanyProfileCard() {
  const [c, setC] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/settings/company").then((r) => setC(r.data)).catch(() => toast.error("Could not load company profile")); }, []);
  const set = (k, v) => setC((p) => ({ ...p, [k]: v }));
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.patch("/settings/company", c); setC(data); toast.success("Company details saved — invoices and PDFs updated"); }
    catch (e) { toast.error(e.response?.data?.detail || "Save failed"); } finally { setBusy(false); }
  };
  if (!c) return null;
  return (
    <div className="hp-card p-5 space-y-4" data-testid="company-profile-card">
      <div>
        <h3 className="font-heading font-bold flex items-center gap-2"><Buildings size={18} className="text-primary" /> Company details on invoices</h3>
        <p className="text-sm text-muted-foreground">Printed under the logo on every invoice PDF and the invoice page: legal name, address and tax registration number.</p>
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        <F label="Legal name" className="sm:col-span-2"><Input className="rounded-sm" value={c.legal_name} onChange={(e) => set("legal_name", e.target.value)} data-testid="company-legal-name" /></F>
        <F label="Address (one line per row)" className="sm:col-span-2"><Textarea rows={3} className="rounded-sm" placeholder={"Office 1203, Building X\nDubai Healthcare City\nDubai, United Arab Emirates"} value={c.address} onChange={(e) => set("address", e.target.value)} data-testid="company-address" /></F>
        <F label="Tax label"><Input className="rounded-sm" placeholder="TRN / VAT No. / Tax ID" value={c.tax_label} onChange={(e) => set("tax_label", e.target.value)} data-testid="company-tax-label" /></F>
        <F label="Tax registration number"><Input className="rounded-sm font-mono" placeholder="100XXXXXXXXXXXX" value={c.tax_number} onChange={(e) => set("tax_number", e.target.value)} data-testid="company-tax-number" /></F>
        <F label="Phone"><Input className="rounded-sm" value={c.phone} onChange={(e) => set("phone", e.target.value)} data-testid="company-phone" /></F>
        <F label="Email"><Input className="rounded-sm" value={c.email} onChange={(e) => set("email", e.target.value)} data-testid="company-email" /></F>
        <F label="Website" className="sm:col-span-2"><Input className="rounded-sm" placeholder="www.heliopolispharmaceuticals.com" value={c.website} onChange={(e) => set("website", e.target.value)} data-testid="company-website" /></F>
      </div>
      <div className="flex justify-end"><Button className="rounded-sm" disabled={busy} onClick={save} data-testid="company-save">{busy ? "Saving…" : "Save company details"}</Button></div>
    </div>
  );
}
